import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { ActivityResultSettingsService } from "../../../shared/services/activity-result-settings.service";
import { LookupService } from "../../../shared/services/lookup.service";
import { ActivityResultSettingDto } from "../../../shared/models/activity/activity-result-setting-dto";
import { ActivityStatusEnum, ContragentType } from "../../../shared/enums";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { forkJoin } from "rxjs";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { ComponentPageBase } from "../../../shared/components/component-page-base/component-page-base";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../../../app.service";
import { NotificationService } from "../../../core/services/notification.service";
import { EntityViewModel } from "../../../shared/models/core/EntityViewModel";
import { ActivitiesService } from "../../../shared/services/activities.service";
import { ActivityStatusesService } from "../../../shared/services/activity-statuses.service";
import { WorkFlowStepTypeEnum } from "../../../shared/enums/workflow-step-type.enum";

@Component({
    selector: 'activity-result-setting-modal',
    templateUrl: './activity-result-setting-modal.html',
    styleUrls: ['./activity-result-setting-modal.scss', 
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss'],
})
export class ActivityResultSettingsModal extends ComponentPageBase<ActivityResultSettingDto> implements OnInit {
    
    @Input() setting: ActivityResultSettingDto = null;

    @Output() cancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() continueEvent: EventEmitter<any> = new EventEmitter<any>();

    requestTypes: KeyValueObject[] = [];
    contragents: KeyValueObject[] = [];
    activityStatuses: KeyValueObject[] = [];
    activityResults: KeyValueObject[] = [];

    dataLoading: boolean = false;

    constructor(
        protected activitiesService: ActivitiesService,
        protected lookupService: LookupService,
        protected activityStatusesService: ActivityStatusesService,
        protected activityResultSettingsService: ActivityResultSettingsService,
        protected route: ActivatedRoute,
        protected router: Router,
        protected appService: AppService,
        protected notificationService: NotificationService,
    ) { 
        super(route, router, appService, notificationService, activityResultSettingsService);
        this.listPageRoutePath = 'categories/activity-result-settings';
		this.appService.pageTitle = 'Результат активности';
        this.entityName = "Результат активности";
    }
    
    ngOnInit(): void {
        this.entityViewModel = new EntityViewModel<ActivityResultSettingDto>();
        if (this.setting != null) {
            this.entityViewModel.entity = this.setting;
            this.isNew = this.entityViewModel.entity.activityResultSettingId == null;
        }
        else {
            this.entityViewModel.entity = new ActivityResultSettingDto();
            this.entityViewModel.entity.isArrivedToTSC = true;
            this.isNew = true;
        }

        this.dataLoading = true;
        var clientsState: DataSourceRequestState = {
			filter:{
				logic: "and",
				filters: [{field: 'contragentTypeId', operator: 'eq', value: <number>ContragentType.bankEquer}]
			}
		};

        var activityStatusState: DataSourceRequestState = { 
            skip: 0, 
            take: null, 
            filter: { logic: "and", filters: [{ field: "WorkFlowStepTypeId", operator: "eq", value: WorkFlowStepTypeEnum.final }] }}

        const requestTypes$ = this.lookupService.getData('request-types', null);
        const contragents$ = this.lookupService.getData('contragents', clientsState);
        const activityStatuses$ = this.activityStatusesService.getLookupData(activityStatusState);
        const activityResults$ = this.activitiesService.getAllActivityResults();

        forkJoin([requestTypes$, contragents$, activityStatuses$, activityResults$])
        .subscribe(([requestTypes, contragents, activityStatuses, activityResults]) => {
            this.requestTypes = requestTypes;
            this.contragents = contragents;
            this.activityStatuses = activityStatuses;
            this.activityResults = activityResults.map(x => new KeyValueObject(x.activityResultId, x.activityResult));

            if (this.isNew && this.activityStatuses.some(x => x.id == <number>ActivityStatusEnum.workEnded)) {
                this.entityViewModel.entity.nextActivityStatusId = <number>ActivityStatusEnum.workEnded;
            }

            this.dataLoading = false;
        });
    }

    cancel() {
        this.cancelEvent.emit();
    }

    afterSaveChanges() {
        this.continueEvent.emit();
    }

    get externalStatusPriorityRequired(): boolean {
        return this.entityViewModel.entity.externalStatus != null && this.entityViewModel.entity.externalStatus.trim() != '';
    }
}